import PhoneInput from "react-phone-input-2";
import 'react-phone-input-2/lib/style.css';

const CommanPhoneNumber = ({ value, handleMobileNumber }: any) => {
    const handlePhone = (value: any, code: any) => {
        const regex = new RegExp(code?.dialCode)
        const phone = value.replace(regex, "");
        handleMobileNumber(value, code, phone)
    }
    return (
        <>
            <PhoneInput
                containerClass="phone-code-select"
                inputClass="phone-code-input"
                placeholder=""
                // onlyCountries={['us']}
                disableInitialCountryGuess={false}
                enableLongNumbers={false}
                country={"us"}
                countryCodeEditable={false}
                value={value}
                onChange={handlePhone}
            />
        </>
    )
}

export default CommanPhoneNumber;
